import React, { useRef, useState } from 'react';
import { FMessage } from '../../hoc/IntlComponents';

const CollapsibleSection = ({ isCollapsed, children }) => {
  const ref = useRef();
  return (
    <div
      style={
        ref.current && {
          height: isCollapsed ? ref.current.offsetHeight : 0,
        }
      }
      className="contracts-opening-words__collapsible"
    >
      <div ref={ref}>{children}</div>
    </div>
  );
};

const ContractsOpeningWords = () => {
  const [isDocExchangeSectionCollapsed, setisDocExchangeSectionCollapsed] = useState(false);

  return (
    <div className="contracts-opening-words">
      <h6>
        <b>
          <FMessage id="contracts.head.text" />
        </b>
      </h6>
      <p>
        <FMessage id="contracts.p1" />
      </p>
      <p>
        <FMessage id="contracts.p2" />
      </p>
      <p>
        <FMessage id="contracts.p3" />
        &nbsp;
        <a href="https://www.diadoc.ru" rel="noopener noreferrer">
          <FMessage id="contracts.kontur-diadoc" />.
        </a>
      </p>
      <p role="button" onClick={() => setisDocExchangeSectionCollapsed((prev) => !prev)}>
        <span className="link pseudo-link">
          <FMessage id="contracts.connect-exchange" />
        </span>
      </p>
      <CollapsibleSection isCollapsed={isDocExchangeSectionCollapsed}>
        <p>
          <FMessage id="contracts.docexchange.p1" />
        </p>
        <ol>
          <li>
            <FMessage id="contracts.docexchange.li1.part1" />
            &nbsp;
            <a href="https://www.diadoc.ru" rel="noopener noreferrer">
              <FMessage id="contracts.kontur-diadoc" />
            </a>
            &nbsp;
            <FMessage id="contracts.docexchange.li1.part2" />
          </li>
          <li>
            <FMessage id="contracts.docexchange.li2" />
          </li>
          <li>
            <FMessage id="contracts.docexchange.li3" />
          </li>
          <li>
            <FMessage id="contracts.docexchange.li4" />
          </li>
        </ol>
        <p style={{ paddingBottom: 16 }}>
          <FMessage id="contracts.docexchange.p2" />
        </p>
      </CollapsibleSection>
    </div>
  );
};

export default ContractsOpeningWords;
